import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { OrganizationDocumentsViewTopBar } from "./TopBar"

export const organizationDocumentsViewLayoutHandle: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: OrganizationDocumentsViewTopBar,
}
